import SpaceDashboardRoundedIcon from '@mui/icons-material/SpaceDashboardRounded';
import LibraryBooksRoundedIcon from '@mui/icons-material/LibraryBooksRounded';
import AutoStoriesRoundedIcon from '@mui/icons-material/AutoStoriesRounded';
import FolderCopyRoundedIcon from '@mui/icons-material/FolderCopyRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import MonitorHeartRoundedIcon from '@mui/icons-material/MonitorHeartRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import { ROUTES } from './paths';

// Sidebar navigation, grouped into sections. `end` marks routes that should only match exactly.
export const MENU = [
  {
    section: 'Overview',
    items: [
      { label: 'Dashboard', path: ROUTES.DASHBOARD, icon: SpaceDashboardRoundedIcon, end: true },
      { label: 'Costs', path: ROUTES.COSTS, icon: PaidRoundedIcon },
    ],
  },
  {
    section: 'Content',
    items: [
      { label: 'Library', path: ROUTES.LIBRARY, icon: AutoStoriesRoundedIcon },
      { label: 'Catalog', path: ROUTES.CATALOG, icon: LibraryBooksRoundedIcon },
      { label: 'Documents', path: ROUTES.DOCUMENTS, icon: FolderCopyRoundedIcon },
    ],
  },
  {
    section: 'System',
    items: [
      { label: 'System Health', path: ROUTES.SYSTEM, icon: MonitorHeartRoundedIcon },
      { label: 'Settings', path: ROUTES.SETTINGS, icon: SettingsRoundedIcon },
    ],
  },
];

export default MENU;
